export function formatForDataTable(employeeData, employmentStatusAcaTypes) {
	return employeeData.map((employee) => {
		const foundType = employmentStatusAcaTypes[employee.employmentStatusId];
		if (!foundType) {
			return employee;
		}
		return Object.assign(employee, { acaType: foundType.acaStatus ? foundType.acaStatus : null });
	});
}
